import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import "./style.scss";
import { Menu, Dropdown } from "antd";

export default () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const [userInfo, setUserInfo] = useState(null);

  const handleLogout = () => {
    if (pathname.match("creditorUser") || pathname.match("user")) {
      history.push("/?callback=logout");
    } else {
      localStorage.clear();
      history.push("/?callback=logout");
      window.location.reload();
    }
  };
  const avatarMenu = (
    <Menu>
      <Menu.Item>
        <span className={"login-choose-logout"} onClick={handleLogout}>
          退出登录
        </span>
      </Menu.Item>
    </Menu>
  );
  useEffect(() => {
    if (localStorage.userType) {
      setUserInfo(JSON.parse(localStorage.userInfo));
    }
  }, []);
  return (
    <ul className={"login-choose"}>
      <li>
        {localStorage.userType === "1" ? (
          <div className={"gUser_name"}>
            <Dropdown overlay={avatarMenu} placement="bottomCenter" arrow>
              {/*user*/}
              <Link to={"/user"}>
                <img
                  src={
                    userInfo?.avatar
                      ? userInfo.avatar
                      : "https://api.faeping.com/storage/uploads/20250403/1743665135068_%E6%99%AE%E9%80%9A%E7%94%A8%E6%88%B72x.png"
                  }
                  alt=""
                />
                {userInfo?.nickname || userInfo?.phone}
              </Link>
            </Dropdown>
          </div>
        ) : (
          <div>
            <img
              src="https://api.faeping.com/storage/uploads/20250403/1743665461198_icon%EF%BC%8F%E7%99%BB%E5%BD%952x.png"
              alt=""
            />
            <Link to={"/login/g_login"}>用户登录</Link>
          </div>
        )}
      </li>
      <li>
        {localStorage.userType === "2" ? (
          <div className={"creditorUser_name"}>
            <Dropdown overlay={avatarMenu} placement="bottomCenter" arrow>
              {/*creditorUser*/}
              <Link to={userInfo?.delete_sign === 0 ? "/creditorUser" : ""}>
                <img
                  src="https://api.faeping.com/storage/uploads/20250403/1743665135068_%E5%A4%B4%E5%83%8F2x.png"
                  alt=""
                />
                {userInfo?.realname}
              </Link>
            </Dropdown>
          </div>
        ) : (
          <div>
            <img
              src="https://api.faeping.com/storage/uploads/20250403/1743665461198_icon%EF%BC%8F%E7%99%BB%E5%BD%952x.png"
              alt=""
            />
            <Link to={"/login/c_login"}>债权人登录</Link>
          </div>
        )}
      </li>
    </ul>
  );
};
